<template>
    <header>
        <template v-if="media">
            <div v-if="media.type === 'image'" class="header" :style="backgroundImage"></div>
            <div v-else class="responsive-video">
                <iframe v-if="media.type === 'youtube'" width="860" height="484"
                        :src="`https://www.youtube-nocookie.com/embed/${media.url}?rel=0&amp;showinfo=0`"
                        allow="autoplay; encrypted-media" allowfullscreen></iframe>
                <iframe v-if="media.type === 'vimeo'" width="860" height="484"
                        :src="`https://player.vimeo.com/video/${media.url}?title=0&byline=0&portrait=0&badge=0`"
                        webkitallowfullscreen mozallowfullscreen allowfullscreen></iframe>
            </div>
        </template>
        <Progress v-if="renderProgressBar" :questions="progress_questions"/>
    </header>
</template>

<script>
import Progress from './Progress.vue'

export default {
    name: 'Header',
    components: {
        Progress
    },
    props: ['media', 'progress_questions',],
    data: function () {
        return {
            background: null,
        }
    },
    methods: {},
    computed: {
        renderProgressBar() {
            return this.index !== null;
        },
        backgroundImage() {
            return "background-image: url(" + this.media.url + ");";
        }
    }
}
</script>
